<template>
  <div class="w-100 d-f fd-c">
    <RatingStars
      v-for="ro in getRatingOptions"
      :key="ro"
      :title="ro"
      :value="currentRating[ro] ?? 0"
      :readonly="!isReceiver"
      @rated="ratingUpdated(ro, $event)"
    />

    <div v-if="!isNaN(averageRating)" class="mute">
      <RatingStars title="Summary" :value="averageRating" readonly />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import * as Utils from "@/utils/demoUtils";
import { rtdb } from "@/db";
import RatingStars from "@/components/demos/RatingStars.vue";

export default {
  name: "DemoRatings",
  components: { RatingStars },
  props: {
    demoData: {
      type: Object,
    },
    autoSave: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      newRatings: {},
    };
  },
  methods: {
    ratingUpdated(k, v) {
      if (this.autoSave) {
        this.demoDbRatingsRef?.update({ [k]: v });
      } else {
        this.$set(this.newRatings, k, v);
      }
    },

    async save() {
      await this.demoDbRatingsRef?.update(this.newRatings);
      this.newRatings = {};
    },
  },
  computed: {
    ...mapState(["userType", "selectedReviewer"]),
    ...mapGetters(["getRatingOptions", "isReceiver", "activeReviewerId"]),

    currentRating() {
      if (this.isReceiver) {
        const reviewerId = this.activeReviewerId;
        if (!reviewerId) return {};
        const ratings =
          (this.demoData?.ratings ?? {})[reviewerId] ?? {};
        return { ...ratings, ...this.newRatings };
      }

      return Object.fromEntries(
        this.getRatingOptions.map((ro) => [
          ro,
          Utils.getAverageRatingOfRatingOption(
            this.demoData?.ratings ?? {},
            ro
          ),
        ])
      );
    },

    averageRating() {
      return Utils.getAverageRating(this.currentRating);
    },

    demoDbRatingsRef() {
      if (!this.isReceiver || !this.demoData || !this.activeReviewerId) {
        return null;
      }

      return rtdb.ref(
        `demoSubmissions/${this.demoData.id}/ratings/${this.activeReviewerId}`
      );
    },
  },
};
</script>

<style scoped lang="scss"></style>
